import { telnumberRegExp, emailRegExp } from './regExp'

/**
 * 非空校验
 * @param {string} value 输入的值
 * @returns {boolean} 是否通过验证 true: 通过 false: 未通过
 */
const notEmptyValidator = (value: string) => value.trim().length > 0

/**
 * 仅允许英文、数字、空格、&、'、-、.
 * @param {string} value 输入的值
 * @returns {boolean} 是否通过验证 true: 通过 false: 未通过
 */
const onlyAllowEnglishValidator = (value: string) => /^[a-zA-Z0-9\s&'-.]+$/.test(value)

/**
 * 手机号校验
 * @param {string} phone 手机号
 * @param {boolean} isAlert 是否显示错误提示
 * @returns {boolean} 是否通过验证 true: 通过 false: 未通过
 */
const phoneValidator = (phone: string, isAlert = true) => {
  if (!telnumberRegExp.test(phone)) {
    isAlert && MessagePlugin('error', '请输入正确的手机号码')
    return false
  }
  return true
}

/**
 * 邮箱校验
 * @param {string} email 邮箱
 * @returns {boolean} 是否通过验证 true: 通过 false: 未通过
 */
const emailValidator = (email: string) => {
  if (!emailRegExp.test(email)) {
    MessagePlugin('error', '请输入正确的邮箱')
    return false
  }
  return true
}

export { notEmptyValidator, onlyAllowEnglishValidator, phoneValidator, emailValidator }
